











import Vue, { PropType } from 'vue';
import { setTimeout, clearTimeout } from 'timers';

export default Vue.extend({
  name: 'Toast',
  props: {
    type: {
      type: String,
      default: 'info',
    },
    initialVisible: {
      type: Boolean,
      default: true,
    },
    autoClose: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: this.initialVisible,
      autoCloseTimeout: null as NodeJS.Timeout | null,
    };
  },
  mounted() {
    if (this.visible) {
      this.$emit('show');
      this.setupAutoClose();
    }
  },
  watch: {
    initialVisible(value) {
      this.visible = value;
    },
    visible(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.$emit(newValue ? 'show' : 'hide');
        if (newValue) {
          this.setupAutoClose();
        }
      }
    },
  },
  methods: {
    hide(): void {
      this.visible = false;
    },
    setupAutoClose(): void {
      if (this.autoClose && this.autoClose > 0) {
        this.autoCloseTimeout = setTimeout(() => {
          this.hide();
        }, this.autoClose);
      }
    },
    removeAutoClose(): void {
      if (this.autoCloseTimeout) {
        clearTimeout(this.autoCloseTimeout);
        this.autoCloseTimeout = null;
      }
    },
  },
});
